import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-210cce29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "erro" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormularioComponent = _resolveComponent("FormularioComponent")!
  const _component_RelatorioComponent = _resolveComponent("RelatorioComponent")!

  return (_ctx.erroAoCarregar)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createElementVNode("article", _hoisted_2, " Erro ao carregar a tela de respostas: " + _toDisplayString(_ctx.erroAoCarregar), 1)
      ]))
    : (_openBlock(), _createElementBlock("main", _hoisted_3, [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.modoFormulario)
              ? (_openBlock(), _createBlock(_component_FormularioComponent, {
                  key: 0,
                  formulario: (_ctx.formulario as Formulario),
                  processadorFormulario: (_ctx.processadorFormulario as ProcessadorDeRespostaDeFormulario),
                  onGerouRelatorio: _ctx.gerouRelatorio
                }, null, 8, ["formulario", "processadorFormulario", "onGerouRelatorio"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (!_ctx.modoFormulario)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textosProcessados, (textoRelatorio) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (!_ctx.modoFormulario)
                        ? (_openBlock(), _createBlock(_component_RelatorioComponent, {
                            key: textoRelatorio.id,
                            relatorio: textoRelatorio
                          }, null, 8, ["relatorio"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256)),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.voltouParaFormulario && _ctx.voltouParaFormulario(...args)))
                  }, " Voltar para o Formulário ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
}